var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        title: "商品管理-" + (_vm.initDetail.labelName || ""),
        size: "80%",
        direction: "rtl",
        visible: _vm.visibleDrawer,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleDrawer = $event
        },
        close: _vm.closeDrawer,
      },
    },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                { attrs: { inline: "", size: "small" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "SKUID" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入skuid",
                          size: "small",
                          clearable: "",
                          maxlength: "50",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.handleNumberSearchInput("skuId")
                          },
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handerSearch($event)
                          },
                        },
                        model: {
                          value: _vm.listPram.skuId,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "skuId", $$v)
                          },
                          expression: "listPram.skuId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品名称" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入商品名称",
                          size: "small",
                          clearable: "",
                          maxlength: "50",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handerSearch($event)
                          },
                        },
                        model: {
                          value: _vm.listPram.productName,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "productName", $$v)
                          },
                          expression: "listPram.productName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.handerSearch },
                        },
                        [_vm._v("搜索")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.handleResetSearch },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "flex-btn" }, [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "mr10",
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.addProducts },
                      },
                      [_vm._v("选择商品")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "mr10",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.handlerOpenEdit()
                          },
                        },
                      },
                      [_vm._v("导入添加")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "mr10",
                        attrs: {
                          size: "small",
                          type: "danger",
                          disabled: !_vm.selectIds || !_vm.selectIds.length,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.batchRemove(_vm.selectIds)
                          },
                        },
                      },
                      [_vm._v("批量移除")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "skuId", label: "skuid", "min-width": "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "image", label: "图片", "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.image
                          ? _c("el-image", {
                              staticStyle: { width: "36px", height: "36px" },
                              attrs: {
                                src: scope.row.image,
                                "preview-src-list": [scope.row.image],
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "skuCode",
                  label: "sku编码",
                  "min-width": "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              scope.row.skuCode || scope.row.spuCode || "-"
                            ) +
                            "\n\t\t\t\t\t"
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "storeName", label: "名称", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(_vm._s(scope.row.storeName || scope.row.name)),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(_vm._s(scope.row.status ? "已上架" : "未上架")),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "brandName", label: "品牌", "min-width": "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "supplierName",
                  label: "供应商",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "100",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.batchRemove([
                                  scope.row.skuId != null
                                    ? scope.row.skuId
                                    : scope.row.id,
                                ])
                              },
                            },
                          },
                          [_vm._v("移除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.editDialogConfig.visible,
            title: "导入商品",
            top: "60px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.editDialogConfig, "visible", $event)
            },
          },
        },
        [
          _c("el-alert", {
            attrs: {
              type: "warning",
              "show-icon": "",
              closable: false,
              title: "请下载模板，上传商品skuId",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex", staticStyle: { "margin-top": "20px" } },
            [
              _c("div", [_vm._v("模版下载：")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small", plain: "" },
                  on: { click: _vm.downModal },
                },
                [_vm._v("模版文件")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex", staticStyle: { "margin-top": "20px" } },
            [
              _c("div", { staticStyle: { height: "43px" } }, [
                _vm._v("文件选择："),
              ]),
              _vm._v(" "),
              _c("ButtonUploadExcel", { attrs: { onSuccess: _vm.onSuccess } }, [
                _c("span", [_vm._v("上传商品")]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editDialogConfig.visible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.importLoading },
                  on: { click: _vm.submitImport },
                },
                [_vm._v("确认绑定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("SelectProducts", {
        ref: "selectProductsRef",
        attrs: {
          selectType: 2,
          "sku-only": true,
          "bind-select-api": _vm.bindSelectListApi,
          fromType: 6,
          "close-before-emit": false,
        },
        on: {
          getSelectProduct: _vm.getSelectProduct,
          doRefresh: function ($event) {
            return _vm.handerSearch(1)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.conflictDialog.visible,
            width: "560px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.conflictDialog, "visible", $event)
            },
            close: _vm.handleConflictDialogClose,
          },
        },
        [
          _c("div", { staticClass: "conflict-message" }, [
            _vm._v(_vm._s(_vm.conflictDialog.message)),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleConflictAction(null)
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _vm.conflictDialog.scene === 3
                ? _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.handleConflictAction(2)
                        },
                      },
                    },
                    [_vm._v("仅导入正常SKUID")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleConflictAction(1)
                    },
                  },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }